export const getCopyTagViewStyle = () => ({
  container: {
    fontSize: '14px',
    marginLeft: 26,
    marginBottom: 12,
  },
});
